// Piko's Garden items + Sticker Book catalogue. Costs in stars.
export const GARDEN_ITEMS = [
  { id: 'flower_red', name: ['Bunga Merah', 'Red Flower'], cost: 2, kind: 'flower', color: 'red', free: true },
  { id: 'flower_blue', name: ['Bunga Biru', 'Blue Flower'], cost: 2, kind: 'flower', color: 'blue', free: true },
  { id: 'flower_yellow', name: ['Bunga Kuning', 'Yellow Flower'], cost: 2, kind: 'flower', color: 'yellow', free: true },
  { id: 'butterfly', name: ['Rama-rama', 'Butterfly'], cost: 3, emoji: '🦋', free: true },
  { id: 'stone', name: ['Batu Hiasan', 'Pretty Stone'], cost: 2, emoji: '🪨', free: true },
  { id: 'tree', name: ['Pokok Kecil', 'Small Tree'], cost: 4, emoji: '🌳' },
  { id: 'mushroom', name: ['Cendawan', 'Mushroom'], cost: 3, emoji: '🍄' },
  { id: 'ladybug', name: ['Kumbang', 'Ladybug'], cost: 3, emoji: '🐞' },
  { id: 'rainbow', name: ['Pelangi', 'Rainbow'], cost: 6, emoji: '🌈' },
  { id: 'cloud', name: ['Awan Lembut', 'Soft Cloud'], cost: 3, emoji: '☁️' },
  { id: 'ball_toy', name: ['Bola Piko', "Piko's Ball"], cost: 4, img: '/assets/objects/obj_ball.webp' },
  { id: 'duck_friend', name: ['Kawan Itik', 'Duck Friend'], cost: 5, img: '/assets/objects/obj_duck.webp' },
];

export const GARDEN_SLOTS = [
  { x: 14, y: 66 }, { x: 32, y: 74 }, { x: 52, y: 68 }, { x: 72, y: 76 }, { x: 86, y: 64 },
  { x: 22, y: 84 }, { x: 44, y: 86 }, { x: 66, y: 88 }, { x: 84, y: 82 },
  { x: 12, y: 44 }, { x: 78, y: 46 }, { x: 50, y: 50 },
];

// Sticker earned on first completion of each game.
export const STICKERS = {
  // Every game needs a sticker. A game without one switches to the sticker
  // phase, renders nothing, and strands the child on a blank screen.
  // ── Drag batch (2026-07-29). All 16 present from the first commit: a game
  // without a sticker renders nothing and strands the child on a blank screen.
  shape_post: { emoji: '📬', name: ['Peti Bentuk', 'Shape Post Box'] },
  shape_shadow: { emoji: '🌑', name: ['Bayang Bentuk', 'Shape Shadow'] },
  animal_feed: { emoji: '🥕', name: ['Lobak Sedap', 'Tasty Carrot'] },
  animal_home_drag: { emoji: '🪺', name: ['Sarang Hangat', 'Cosy Nest'] },
  colour_basket: { emoji: '🪣', name: ['Baldi Warna', 'Colour Bucket'] },
  colour_paint: { emoji: '🎨', name: ['Berus Piko', "Piko's Brush"] },
  sound_drag: { emoji: '🎤', name: ['Mikrofon', 'Microphone'] },
  music_maker: { emoji: '🎶', name: ['Muzik Piko', "Piko's Music"] },
  bring_back: { emoji: '🧲', name: ['Magnet Ingatan', 'Memory Magnet'] },
  pack_bag: { emoji: '👜', name: ['Beg Piko', "Piko's Bag"] },
  size_nest: { emoji: '🕳️', name: ['Lubang Besar', 'Big Hole'] },
  stack_ring: { emoji: '🍩', name: ['Gelang Warna', 'Colour Rings'] },
  drag_path: { emoji: '🛤️', name: ['Jalan Piko', "Piko's Path"] },
  fruit_pick: { emoji: '🍒', name: ['Ceri Manis', 'Sweet Cherry'] },
  tidy_up: { emoji: '🧹', name: ['Penyapu Kemas', 'Tidy Broom'] },
  give_piko: { emoji: '💧', name: ['Air Sejuk', 'Cool Water'] },
  shape_same: { emoji: '🔵', name: ['Bulat Kembar', 'Twin Circle'] },
  touch_animal: { emoji: '🐾', name: ['Tapak Kaki', 'Paw Print'] },
  fast_slow: { emoji: '🐇', name: ['Arnab Laju', 'Fast Rabbit'] },
  long_short: { emoji: '🪢', name: ['Tali Panjang', 'Long Rope'] },
  same_picture: { emoji: '🃏', name: ['Kad Kembar', 'Twin Cards'] },
  piko_piano: { emoji: '🎹', name: ['Piano Piko', "Piko's Piano"] },
  tap_colour: { emoji: '🔴', name: ['Bola Merah', 'Red Ball'] },
  colour_match: { emoji: '🪴', name: ['Pasu Bunga', 'Flower Pot'] },
  colour_feed: { emoji: '🍎', name: ['Buah Manis', 'Sweet Fruit'] },
  loud_soft: { emoji: '🥁', name: ['Dram Besar', 'Big Drum'] },
  tap_shape: { emoji: '🔺', name: ['Tiga Segi', 'Triangle'] },
  shape_hole: { emoji: '🧩', name: ['Puzzle Bentuk', 'Shape Puzzle'] },
  shape_find: { emoji: '⚪', name: ['Si Bulat', 'Round One'] },
  many_few: { emoji: '🍇', name: ['Buah Banyak', 'Lots of Fruit'] },
  tall_short: { emoji: '🌴', name: ['Pokok Tinggi', 'Tall Tree'] },
  animal_name: { emoji: '🐶', name: ['Kawan Haiwan', 'Animal Friend'] },
  animal_home: { emoji: '🐠', name: ['Ikan Emas', 'Goldfish'] },
  animal_baby: { emoji: '🐣', name: ['Anak Ayam', 'Baby Chick'] },
  pop_bubble: { emoji: '🫧', name: ['Buih Ceria', 'Happy Bubbles'] },
  catch_star: { emoji: '🌠', name: ['Bintang Jatuh', 'Shooting Star'] },
  tap_dots: { emoji: '💡', name: ['Lampu Ajaib', 'Magic Light'] },
  object_name: { emoji: '🥄', name: ['Sudu Kecil', 'Little Spoon'] },
  object_use: { emoji: '🥤', name: ['Cawan Piko', "Piko's Cup"] },
  body_part: { emoji: '👃', name: ['Hidung Comel', 'Cute Nose'] },
  play_together: { emoji: '🤝', name: ['Main Bersama', 'Together Time'] },
  baskets: { emoji: '🧺', name: ['Bakul', 'Basket'] },
  odd_one: { emoji: '🌸', name: ['Bunga Istimewa', 'Special Flower'] },
  animal_sound: { emoji: '🐱', name: ['Kucing', 'Cat'] },
  object_sound: { emoji: '🔔', name: ['Loceng', 'Bell'] },
  disappeared: { emoji: '☁️', name: ['Awan Ajaib', 'Magic Cloud'] },
  colour_trail: { emoji: '👣', name: ['Jejak', 'Trail'] },
  pattern: { emoji: '🌼', name: ['Corak', 'Pattern'] },
  detective: { emoji: '🔍', name: ['Detektif', 'Detective'] },
  listen_choose: { emoji: '👂', name: ['Pendengar', 'Listener'] },
  sound_seq: { emoji: '🎵', name: ['Muzik', 'Music'] },
  piko_says: { emoji: '👏', name: ['Tepukan', 'Clap'] },
  location: { emoji: '📍', name: ['Lokasi', 'Location'] },
  pair: { emoji: '🃏', name: ['Pasangan', 'Pair'] },
  copy_piko: { emoji: '🔁', name: ['Peniru Hebat', 'Great Copier'] },
  magic_bag: { emoji: '🎒', name: ['Beg Ajaib', 'Magic Bag'] },
  sort_world: { emoji: '📦', name: ['Penyusun', 'Sorter'] },
  two_step: { emoji: '🏅', name: ['Misi Berganda', 'Double Mission'] },
  big_small: { emoji: '🍄', name: ['Cendawan Gergasi', 'Giant Mushroom'] },
  pattern_pro: { emoji: '👑', name: ['Mahkota Corak', 'Pattern Crown'] },
  sound_master: { emoji: '🎧', name: ['Pakar Bunyi', 'Sound Master'] },
  echo_seq: { emoji: '💎', name: ['Kristal Gema', 'Echo Crystal'] },
  super_pair: { emoji: '🐠', name: ['Ikan Kembar', 'Twin Fish'] },
  mega_trail: { emoji: '🏔️', name: ['Puncak Mega', 'Mega Peak'] },
};

// Daily return reward stickers (cycled by visit count).
export const DAILY_STICKERS = [
  { id: 'daily_0', emoji: '🌞', name: ['Matahari Ceria', 'Happy Sun'] },
  { id: 'daily_1', emoji: '🌈', name: ['Pelangi Piko', "Piko's Rainbow"] },
  { id: 'daily_2', emoji: '🦖', name: ['Dino Kecil', 'Little Dino'] },
  { id: 'daily_3', emoji: '🎈', name: ['Belon Merah', 'Red Balloon'] },
  { id: 'daily_4', emoji: '🍓', name: ['Strawberi Manis', 'Sweet Strawberry'] },
  { id: 'daily_5', emoji: '🐢', name: ['Kura-kura', 'Turtle'] },
  { id: 'daily_6', emoji: '⭐', name: ['Bintang Emas', 'Gold Star'] },
  { id: 'daily_7', emoji: '🦋', name: ['Rama-rama Biru', 'Blue Butterfly'] },
  { id: 'daily_8', emoji: '🍦', name: ['Aiskrim', 'Ice Cream'] },
  { id: 'daily_9', emoji: '🐳', name: ['Ikan Paus', 'Whale'] },
  { id: 'daily_10', emoji: '🚀', name: ['Roket', 'Rocket'] },
  { id: 'daily_11', emoji: '🌺', name: ['Bunga Raya', 'Hibiscus'] },
  { id: 'daily_12', emoji: '🎁', name: ['Hadiah Ajaib', 'Magic Gift'] },
  { id: 'daily_13', emoji: '👑', name: ['Mahkota Piko', "Piko's Crown"] },
];
